import { useBodyStore } from '@autobid/nuxt-pinia-store/store/useBodyStore'

export function useBody() {
  const { handleOnMounted, handleOnBeforeUnmount } = useBodyStore()

  onMounted(handleOnMounted)
  onBeforeUnmount(handleOnBeforeUnmount)
}
